import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import SlideUpModal from '@/checkout-instore-legacy/components/Commons/Elements/SlideUpModal'
import { loadInStoreOrderForm } from '@/checkout-instore-legacy/order/actions'
import { getVendor } from '@/checkout-instore-legacy/utils/vendorUtils'
import { getReduxStore } from '@/checkout-instore-legacy/redux/reduxStore'
import * as UrlUtils from '@/checkout-instore-legacy/utils/UrlUtils'

function getCurrentLink(location) {
  if (location && location.query && location.query.href) {
    return location.query.href
  }
  return ''
}

function getCurrentIsEcommerce(location) {
  if (location && location.query && location.query.isEcommerce) {
    return !!location.query.isEcommerce
  }
  return ''
}

class CustomLink extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      href: getCurrentLink(this.props.location),
    }

    this.isEcommerce = getCurrentIsEcommerce(this.props.location)

    this.initialPage = window.history.length
  }

  componentDidUpdate(prevProps) {
    const oldHref = getCurrentLink(prevProps.location)
    const currentHref = getCurrentLink(this.props.location)

    if (oldHref !== currentHref) {
      this.isEcommerce = getCurrentIsEcommerce(this.props.location)

      this.setState({
        // Fix iframe update when uri contains '#'
        href: UrlUtils.updateQueryStringParameter(
          currentHref,
          'k',
          Date.now().toString()
        ),
      })
    }
  }

  goToPreviousPage = () => {
    const previousPage = this.initialPage - window.history.length - 1
    if (this.isEcommerce) {
      getReduxStore().dispatch(loadInStoreOrderForm(getVendor()))
    }
    this.props.router.go(previousPage)
  }

  handleClickBackButton = () => {
    try {
      this.iframe.contentWindow.history.go(-1)
    } catch (e) {
      this.props.router.go(-1)
    }
  }

  handleIframeLoad = (ref) => {
    this.iframe = ref
    if (this.iframe) {
      this.iframe.onload = () => {
        const doc = this.iframe && this.iframe.contentDocument
        if (doc && doc.body) {
          doc.body.innerHTML = `${doc.body.innerHTML} <style>#vtex-callcenter{display: none}</style>`
        }
      }
    }
  }

  handleClickClose = this.goToPreviousPage

  render() {
    return (
      <SlideUpModal
        isOpen
        fullScreen
        keepContentSize
        title={this.props.location.query.title}
        onClose={this.handleClickClose}
        onClickBackButton={this.handleClickBackButton}
      >
        <iframe
          className="absolute"
          src={this.state.href}
          frameBorder={0}
          sandbox="allow-forms allow-scripts allow-same-origin"
          ref={this.handleIframeLoad}
          style={{ height: '100%', width: '100%' }}
        />
      </SlideUpModal>
    )
  }
}

CustomLink.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object,
  router: PropTypes.any,
  route: PropTypes.object.isRequired,
}

export default withRouter(CustomLink)
